export default "__VITE_ASSET__0505e9e4__"